import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';


export interface CanComponentDeactivate {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable({
  providedIn: 'root'
})
export class CanDeactivateGuard  {

  canDeactivate(component: CanComponentDeactivate): Observable<boolean> | Promise<boolean> | boolean {
      return component.canDeactivate() ? true : confirm('WARNING: You have unsaved changes. ' +
        'Press Cancel to go back and save these changes, or OK to lose these changes.');
    }
}
